import React, { useState, useEffect, useRef ,useContext} from 'react';
import { useNavigate } from "react-router-dom";
import { Search, Bell, Rocket, X, MapPin } from 'lucide-react';
import LoginModal from '../../../../components/customer/auth/loginModal/LoginModal';

import '../../../../assets/css/subscreens/customer/home/herosection/Herosection.css';
import cleaning from '../../../../assets/images/cleaning.jpg';
import electrition from '../../../../assets/images/electrition.jpg';
import plumber from '../../../../assets/images/plumber.jpg';
import painter from '../../../../assets/images/painter.jpg';
import cook from '../../../../assets/images/cook.jpg';
import axios from "axios";

import AppContext from "../../../../context/AppContext";


const SERVICES = [
  { 
    id: 1, 
    name: 'Deep Cleaning', 
    image: cleaning,
    badge: '30% Off',
    title: 'Special Deals',
    desc: 'Get discount for every order'
  },
  { 
    id: 2, 
    name: 'Electrical Work', 
    image: electrition,
    badge: 'Popular',
    title: 'Expert Service',
    desc: 'Professional electricians'
  },
  { 
    id: 3, 
    name: 'Plumbing', 
    image: plumber,
    badge: 'Trending',
    title: 'Quick Fix',
    desc: 'Fast plumbing solutions'
  },
  { 
    id: 4, 
    name: 'Painting', 
    image: painter,
    badge: 'New',
    title: 'Premium Paint',
    desc: 'Quality painting service'
  },
  { 
    id: 5, 
    name: 'Cooking Services', 
    image: cook,
    badge: 'Best',
    title: 'Home Chef',
    desc: 'Delicious meals daily'
  },
];

function useCountUp(target, duration = 1800, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(ease * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function StatItem({ value, suffix, label, animate }) {
  const count = useCountUp(value, 1800, animate);
  return (
    <div className="wha-stat">
      <span className="wha-stat__value">{count.toLocaleString()}{suffix}</span>
      <span className="wha-stat__label">{label}</span>
    </div>
  );
}

const Trustedservice = () => {
  const navigate = useNavigate();
  const {baseUrl} = useContext(AppContext);

const [stats,setStats] = useState([
  { value:0, suffix:"+", label:"Tasks Done" },
  { value:0, suffix:"+", label:"Skilled Experts" },
  { value:0, suffix:"%", label:"Happy Clients" },
]);
  const [animate, setAnimate] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [parallaxOffset, setParallaxOffset] = useState({ x: 0, y: 0 });
  const sectionRef = useRef(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setAnimate(true); },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Parallax effect on mouse move (desktop only)
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (window.innerWidth <= 768) return; // Disable on mobile
      
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;
      
      const xOffset = ((clientX / innerWidth) - 0.5) * 40;
      const yOffset = ((clientY / innerHeight) - 0.5) * 40;
      
      setParallaxOffset({ x: xOffset, y: yOffset });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % SERVICES.length);
        setIsTransitioning(false);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  //  api lagai states k liya
useEffect(()=>{

 axios.get(`${baseUrl}/customer/herosectionstates`)
 .then(res=>{

    console.log("STATS:",res.data);


    setStats([
      {
        value:res.data.tasks_done,
        suffix:"+",
        label:"Tasks Done"
      },

      {
        value:res.data.experts,
        suffix:"+",
        label:"Skilled Experts"
      },

      {
        value:res.data.happy_clients,
        suffix:"%",
        label:"Happy Clients"
      }
    ]);


 })
 .catch(err=>{
    console.log(err);
 });


},[]);
  const handleDotClick = (index) => {
    if (index !== currentIndex) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex(index);
        setIsTransitioning(false);
      }, 300);
    }
  };

 const handleLaunchApp = () => {
  setShowLoginModal(true); // ✅ modal open
};

  const handleSearchClick = () => {
    setShowSearch(!showSearch);
  };

  const handleSearchClose = () => {
    setShowSearch(false);
    setSearchQuery('');
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log("Search query:", searchQuery);
    navigate(`/search?q=${searchQuery}`);
  };

  const currentService = SERVICES[currentIndex];

  return (
    <section className="wha-section" ref={sectionRef}>
      <div className="wha-bg-circle wha-bg-circle--1" />
      <div className="wha-bg-circle wha-bg-circle--2" />

      {/* Mobile Top Bar */}
      {/* <div className="wha-mobile-topbar">
        <div className="wha-location-badge">
          <MapPin size={14} />
          <span>My Location / Petersburg, St</span>
        </div>
        <div className="wha-mobile-icons">
          <button className="wha-icon-btn" onClick={handleSearchClick}>
            <Search size={20} />
          </button>
          <button className="wha-icon-btn wha-icon-btn--notification">
            <Bell size={20} />
            <span className="wha-notification-dot"></span>
          </button>
        </div>
      </div> */}

      {/* Search Overlay */}
      {showSearch && (
        <div className="wha-search-overlay" onClick={handleSearchClose}>
          <div className="wha-search-box" onClick={(e) => e.stopPropagation()}>
            <form onSubmit={handleSearchSubmit}>
              <Search size={20} className="wha-search-icon" />
              <input
                type="text"
                className="wha-search-input"
                placeholder="Search services..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
              />
              <button type="button" className="wha-search-close" onClick={handleSearchClose}>
                <X size={20} />
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="wha-container">
        {/* LEFT SIDE - Desktop */}
        <div className="wha-left">
          <h2 className="wha-title">
            Reliable Home Solutions<br />
            Right at Your Doorstep
          </h2>
          <p className="wha-desc">
            Get professional home services with ease. From cleaning and repairs to painting and cooking, we connect you with trusted experts for every task.
          </p>
          <div className="wha-stats">
           {stats.map((s) => 
  <StatItem 
    key={s.label} 
    {...s} 
    animate={animate} 
  />
)}
          </div>
          <div className="wha-divider" />
          <div className="wha-footer-row">
            <button className="wha-desktop-launch-btn" onClick={handleLaunchApp}>
              <Rocket size={20} />
              <span>Launch App</span>
            </button>
          </div>
        </div>

        {/* RIGHT SIDE - Desktop Image with Parallax */}
        <div className="wha-right">
          <div className="wha-blob-container">
            <img
              src={currentService.image}
              alt={currentService.name}
              className={`wha-blob-img wha-parallax-img ${isTransitioning ? 'wha-fade' : ''}`}
              style={{
                transform: `translate(${parallaxOffset.x}px, ${parallaxOffset.y}px) scale(1.1) ${isTransitioning ? 'scale(0.95)' : ''}`
              }}
            />
          </div>
        </div>
      </div>
      <LoginModal
  isOpen={showLoginModal}
  onClose={() => setShowLoginModal(false)}
  onLoginSuccess={() => {
    setShowLoginModal(false);
    navigate("/customer-dashboard"); // ya jahan le jana hai
  }}
/>

    </section>
  );
}

export default Trustedservice;